var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalBelongings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st0,\n\t\t.prefix__st1 {\n\t\t\tfill-rule: evenodd;\n\t\t\tclip-rule: evenodd;\n\t\t\tfill: #414141\n\t\t}\n\n\t\t.prefix__st1 {\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-linecap: round;\n\t\t\tstroke-linejoin: round;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M2.2 12H4v10.5H2.2zM20 12h1.8v10.5H20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M0 11.5h24v2H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M12.5 1.5h9.4v6.6h-9.4zM17.2 8.3v4.2M3.9 7.6l-.7 2.7M9.5 10.3H5L3 4.5h4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalBelongings);
export default __webpack_public_path__ + "static/media/personal-belongings.c65a6ead3dc127715e74d570b6a4b62c.svg";
export { ForwardRef as ReactComponent };